// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Gallery {
  display: flex;
  width: 100%;
  gap: 8px;
  height: 400px;
  flex-wrap: wrap;
  margin: 32px auto;
  cursor: pointer;
}

.Gallery .imgDiv {
  height: 100%;
  width: 100%;
  border-radius: 6px;
  box-shadow: var(--box-shadow);
  background-size: cover;
}

.Gallery .imgDiv .overlay {
  color: var(--white);
  position: absolute;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
}

.Gallery .overlay p {
  color: white;
  margin: 0;
  margin-bottom: 4px;
  font-size: 1.3em;
  font-weight: 600;
}

.fullscreenOverlay {
  position: fixed;
  z-index: 30;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0,0,0,0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.currentLightboxImage {
  width: 80vw;
  height: 80vh;
  object-fit: contain;
  background-color: #111;
}

@media (max-width: 850px) {
  .currentLightboxImage {
    height: 50vh;
  }
}

.Gallery .left,
.Gallery .right {
  flex: 1 1 auto;
  min-width: 300px;
}
.Gallery .left {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.Gallery .right {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.Gallery .rightTop,
.Gallery .rightBottom {
  flex: 1 1 auto;
  display: flex;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/css/Gallery.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,QAAQ;EACR,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,QAAQ;AACV","sourcesContent":[".Gallery {\n  display: flex;\n  width: 100%;\n  gap: 8px;\n  height: 400px;\n  flex-wrap: wrap;\n  margin: 32px auto;\n  cursor: pointer;\n}\n\n.Gallery .imgDiv {\n  height: 100%;\n  width: 100%;\n  border-radius: 6px;\n  box-shadow: var(--box-shadow);\n  background-size: cover;\n}\n\n.Gallery .imgDiv .overlay {\n  color: var(--white);\n  position: absolute;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,0.5);\n}\n\n.Gallery .overlay p {\n  color: white;\n  margin: 0;\n  margin-bottom: 4px;\n  font-size: 1.3em;\n  font-weight: 600;\n}\n\n.fullscreenOverlay {\n  position: fixed;\n  z-index: 30;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  background-color: rgba(0,0,0,0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.currentLightboxImage {\n  width: 80vw;\n  height: 80vh;\n  object-fit: contain;\n  background-color: #111;\n}\n\n@media (max-width: 850px) {\n  .currentLightboxImage {\n    height: 50vh;\n  }\n}\n\n.Gallery .left,\n.Gallery .right {\n  flex: 1 1 auto;\n  min-width: 300px;\n}\n.Gallery .left {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.Gallery .right {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.Gallery .rightTop,\n.Gallery .rightBottom {\n  flex: 1 1 auto;\n  display: flex;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
